module.exports = __webpack_public_path__ + "static/media/img_drug.c70a542d.jpg";